import React from 'react';

export const IdentityIcon = props => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.9999 7.99992C17.4666 7.99992 18.6666 9.19992 18.6666 10.6666C18.6666 12.1333 17.4666 13.3333 15.9999 13.3333C14.5333 13.3333 13.3333 12.1333 13.3333 10.6666C13.3333 9.19992 14.5333 7.99992 15.9999 7.99992ZM15.9999 19.9999C19.5999 19.9999 23.7333 21.7199 23.9999 22.6666V23.9999H7.99992V22.6799C8.26659 21.7199 12.3999 19.9999 15.9999 19.9999ZM15.9999 5.33325C13.0533 5.33325 10.6666 7.71992 10.6666 10.6666C10.6666 13.6133 13.0533 15.9999 15.9999 15.9999C18.9466 15.9999 21.3333 13.6133 21.3333 10.6666C21.3333 7.71992 18.9466 5.33325 15.9999 5.33325ZM15.9999 17.3333C12.4399 17.3333 5.33325 19.1199 5.33325 22.6666V26.6666H26.6666V22.6666C26.6666 19.1199 19.5599 17.3333 15.9999 17.3333Z"
      fill="#005D1F"
    />
  </svg>
);

export const LocalAtm = props => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.6667 22.6668H17.3334V21.3335H18.6667C19.4001 21.3335 20.0001 20.7335 20.0001 20.0002V16.0002C20.0001 15.2668 19.4001 14.6668 18.6667 14.6668H14.6667V13.3335H20.0001V10.6668H17.3334V9.3335H14.6667V10.6668H13.3334C12.6001 10.6668 12.0001 11.2668 12.0001 12.0002V16.0002C12.0001 16.7335 12.6001 17.3335 13.3334 17.3335H17.3334V18.6668H12.0001V21.3335H14.6667V22.6668ZM26.6667 5.3335H5.33341C3.85341 5.3335 2.68008 6.52016 2.68008 8.00016L2.66675 24.0002C2.66675 25.4802 3.85341 26.6668 5.33341 26.6668H26.6667C28.1467 26.6668 29.3334 25.4802 29.3334 24.0002V8.00016C29.3334 6.52016 28.1467 5.3335 26.6667 5.3335ZM26.6667 24.0002H5.33341V8.00016H26.6667V24.0002Z"
      fill="#005D1F"
    />
  </svg>
);

export const DescriptionIcon = props => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.6666 21.3332H21.3333V23.9998H10.6666V21.3332ZM10.6666 15.9998H21.3333V18.6665H10.6666V15.9998ZM18.6666 2.6665H7.99992C6.53325 2.6665 5.33325 3.8665 5.33325 5.33317V26.6665C5.33325 28.1332 6.51992 29.3332 7.98658 29.3332H23.9999C25.4666 29.3332 26.6666 28.1332 26.6666 26.6665V10.6665L18.6666 2.6665ZM23.9999 26.6665H7.99992V5.33317H17.3333V11.9998H23.9999V26.6665Z"
      fill="#005D1F"
    />
  </svg>
);

export const AgreementCheck = props => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6 12L9.27368 15.6829C9.66392 16.1219 10.3467 16.1316 10.7493 15.7039L18 8"
      stroke="#231F20"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const InfoIcon = props => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11 7H13V9H11V7ZM11 11H13V17H11V11ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z"
      fill="#0186C9"
    />
  </svg>
);

export const ErrorIcon = props => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.0004 5.54834C21.7402 5.54834 26.452 10.1971 26.452 15.9999C26.452 21.7721 21.7774 26.4516 16.0004 26.4516C10.2306 26.4516 5.54883 21.7792 5.54883 15.9999C5.54883 10.2321 10.2231 5.54834 16.0004 5.54834ZM16 4C9.37305 4 4 9.37498 4 16C4 22.6289 9.37305 28 16 28C22.6269 28 28 22.6289 28 16C28 9.37498 22.6269 4 16 4ZM15.444 9.8064H16.5559C16.8861 9.8064 17.1498 10.0813 17.1361 10.4112L16.7974 18.5403C16.7844 18.8513 16.5285 19.0967 16.2172 19.0967H15.7828C15.4715 19.0967 15.2156 18.8512 15.2026 18.5403L14.8639 10.4112C14.8502 10.0813 15.1139 9.8064 15.444 9.8064ZM15.9994 20.0645C15.2511 20.0645 14.6445 20.671 14.6445 21.4193C14.6445 22.1676 15.2511 22.7741 15.9994 22.7741C16.7476 22.7741 17.3542 22.1676 17.3542 21.4193C17.3542 20.671 16.7476 20.0645 15.9994 20.0645Z"
      fill="#D60000"
    />
  </svg>
);

export const HRBLOGO = props => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="48" height="48" fill="white" />
    <mask
      id="mask0_672_2419"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="48"
      height="48"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.012207 0.0146484H47.9838V47.9999H0.012207V0.0146484Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_672_2419)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.012207 47.9999H47.9838V0.0146484H0.012207V47.9999Z"
        fill="#14AA40"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.4504 33.7064H18.1343L17.7671 33.3085C17.2473 33.6568 16.505 33.8744 15.7184 33.8744C13.4277 33.8744 12.1293 32.7797 12.1293 31.1273C12.1293 29.9384 12.8979 29.1976 13.6358 28.8517C13.0804 28.3391 12.9602 27.7667 12.9602 27.3986C12.9602 26.0887 14.0211 25.2217 15.6724 25.2217C17.1967 25.2217 18.2886 26.0292 18.2886 27.3472V27.8693H16.3057V27.4684C16.3057 27.1348 16.1016 26.8962 15.7184 26.8962C15.3632 26.8962 15.1265 27.1118 15.1265 27.4309C15.1265 27.7054 15.2475 27.8833 15.4346 28.1144L17.3655 30.2742V29.0574H19.2057V30.3547C19.2057 30.8324 19.1637 31.448 18.8761 31.9518L20.4504 33.7064ZM15.668 32.1637C16.0429 32.1637 16.3954 32.0332 16.532 31.938C16.2452 31.6293 14.8863 30.1026 14.8863 30.1026C14.614 30.2879 14.3204 30.6168 14.3204 31.0678C14.3204 31.837 15.1029 32.1637 15.668 32.1637ZM36.5651 44.3602H39.168V40.8963H39.3739L41.0916 44.3602H44.1876L41.7612 39.7923L43.9412 36.0406H41.0219L39.3314 38.9364H39.168V36.0406H36.5651V44.3602ZM44.4383 36.5424C44.4383 36.9067 44.7048 37.2114 45.1295 37.2114C45.5534 37.2114 45.8196 36.9067 45.8196 36.5424C45.8196 36.1798 45.5534 35.8722 45.1295 35.8722C44.7048 35.8722 44.4383 36.1798 44.4383 36.5424ZM45.6702 36.5424C45.6702 36.8461 45.472 37.0851 45.1295 37.0851C44.7883 37.0851 44.591 36.8461 44.591 36.5424C44.591 36.2347 44.7883 35.9999 45.1295 35.9999C45.472 35.9999 45.6702 36.2347 45.6702 36.5424ZM45.2055 36.8125H45.4199L45.3086 36.6164C45.362 36.5787 45.3955 36.5184 45.3955 36.4428C45.3955 36.3123 45.3177 36.2312 45.1654 36.2312H44.899V36.8125H45.0839V36.6515H45.1226L45.2055 36.8125ZM45.0839 36.5087V36.3821H45.141C45.1868 36.3821 45.212 36.4071 45.212 36.4428C45.212 36.4819 45.1868 36.5087 45.141 36.5087H45.0839ZM31.392 42.3625C30.5002 42.3625 30.0746 41.7797 30.0746 40.8642V39.5352C30.0746 38.6197 30.5002 38.0367 31.392 38.0367C32.3066 38.0367 32.64 38.6655 32.6872 39.2746H35.1475C35.0898 37.3943 33.7827 35.8722 31.4404 35.8722C28.7546 35.8722 27.4726 37.3943 27.4726 39.6539V40.7467C27.4726 43.0035 28.7546 44.5251 31.4404 44.5251C33.7827 44.5251 35.0898 43.0035 35.1475 41.1286H32.6872C32.64 41.7355 32.3066 42.3625 31.392 42.3625ZM18.6291 40.7231C18.6291 42.9827 19.9979 44.5251 22.5991 44.5251C25.2034 44.5251 26.5704 42.9827 26.5704 40.7231V39.6771C26.5704 37.4187 25.2034 35.8722 22.5991 35.8722C19.9979 35.8722 18.6291 37.4187 18.6291 39.6771V40.7231ZM23.9686 40.8761C23.9686 41.8379 23.4807 42.3625 22.5991 42.3625C21.7204 42.3625 21.232 41.8379 21.232 40.8761V39.5229C21.232 38.559 21.7204 38.0367 22.5991 38.0367C23.4807 38.0367 23.9686 38.559 23.9686 39.5229V40.8761ZM11.9677 44.3602H17.9444V42.2H14.568V36.0406H11.9677V44.3602ZM3.60022 44.3602H7.97467C9.87592 44.3602 10.8974 43.3994 10.8974 41.9959C10.8974 40.959 10.2916 40.282 9.29528 40.0573C9.98099 39.7251 10.386 39.0346 10.386 38.1912C10.386 36.9434 9.47155 36.0406 7.91457 36.0406H3.60022V44.3602ZM6.07686 39.2875V37.9514H7.28291C7.66731 37.9514 7.91256 38.2335 7.91256 38.5925C7.91256 38.9896 7.69353 39.2875 7.28291 39.2875H6.07686ZM6.05649 42.4501V41.0534H7.78469C8.19894 41.0534 8.45286 41.3711 8.45286 41.7417C8.45286 42.1429 8.21245 42.4501 7.79901 42.4501H6.05649ZM25.7044 33.7064H28.7327L27.0829 31.0809C27.9745 30.5686 28.5084 29.6552 28.5084 28.4633C28.5084 26.6472 27.3566 25.3883 25.2408 25.3883H21.0811V33.7064H23.683V31.5216H24.4332L25.7044 33.7064ZM23.683 29.463V27.4684H24.9441C25.576 27.4684 25.9057 27.8572 25.9057 28.476C25.9057 29.0484 25.5634 29.463 24.9441 29.463H23.683ZM3.60022 25.3883H6.20513V28.3469H8.34355V25.3883H10.9464V33.7064H8.34355V30.7245H6.20513V33.7064H3.60022V25.3883Z"
      fill="white"
    />
  </svg>
);

export const ShareIcon = props => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18 16.12C17.24 16.12 16.56 16.42 16.04 16.89L8.91 12.74C8.96 12.51 9 12.28 9 12.04C9 11.8 8.96 11.57 8.91 11.34L15.96 7.23004C16.5 7.73004 17.21 8.04004 18 8.04004C19.66 8.04004 21 6.70004 21 5.04004C21 3.38004 19.66 2.04004 18 2.04004C16.34 2.04004 15 3.38004 15 5.04004C15 5.28004 15.04 5.51004 15.09 5.74004L8.04 9.85004C7.5 9.35004 6.79 9.04004 6 9.04004C4.34 9.04004 3 10.38 3 12.04C3 13.7 4.34 15.04 6 15.04C6.79 15.04 7.5 14.73 8.04 14.23L15.16 18.39C15.11 18.6 15.08 18.82 15.08 19.04C15.08 20.65 16.39 21.96 18 21.96C19.61 21.96 20.92 20.65 20.92 19.04C20.92 17.43 19.61 16.12 18 16.12ZM18 4.04004C18.55 4.04004 19 4.49004 19 5.04004C19 5.59004 18.55 6.04004 18 6.04004C17.45 6.04004 17 5.59004 17 5.04004C17 4.49004 17.45 4.04004 18 4.04004ZM6 13.04C5.45 13.04 5 12.59 5 12.04C5 11.49 5.45 11.04 6 11.04C6.55 11.04 7 11.49 7 12.04C7 12.59 6.55 13.04 6 13.04ZM18 20.06C17.45 20.06 17 19.61 17 19.06C17 18.51 17.45 18.06 18 18.06C18.55 18.06 19 18.51 19 19.06C19 19.61 18.55 20.06 18 20.06Z"
      fill="#231F20"
    />
  </svg>
);

export const DownloadIcon = props => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18 15V18H6V15H4V18C4 19.1 4.9 20 6 20H18C19.1 20 20 19.1 20 18V15H18ZM17 11L15.59 9.59L13 12.17V4H11V12.17L8.41 9.59L7 11L12 16L17 11Z"
      fill="#231F20"
    />
  </svg>
);

export const MoneyPlusIcon = props => (
  <svg
    width="108"
    height="105"
    viewBox="0 0 108 105"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_d_550_4052)">
      <rect
        x="22"
        y="22"
        width="64"
        height="61.7412"
        rx="12.0471"
        fill="white"
        shapeRendering="crispEdges"
      />
      <rect
        x="28.1538"
        y="27.2476"
        width="51.4769"
        height="50.989"
        rx="6.02353"
        fill="#D2FA52"
      />
      <path
        d="M73.272 57.4073L65.1137 58.998L64.0754 60.1387L60.0091 59.9954L34.6443 64.9466L31.4629 48.6302L70.0854 41.0908L73.272 57.4073Z"
        fill="#F1F5F7"
        stroke="#003512"
        strokeWidth="0.527473"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M68.8459 43.1113L33.2175 50.0368L35.8302 63.4778L71.4586 56.5523L68.8459 43.1113Z"
        fill="#F1F5F7"
        stroke="#003512"
        strokeWidth="0.527473"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.0358 48.8398C38.6905 52.2003 35.2533 52.8704 35.9131 56.2309C36.5678 59.5913 40.0051 58.9213 40.6598 62.2818L35.8671 63.2178L33.2432 49.781L38.0358 48.845V48.8398Z"
        fill="#14AA40"
        stroke="#003512"
        strokeWidth="0.527473"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M66.6996 57.1968C66.0449 53.8363 69.4821 53.1663 68.8222 49.8058C68.1675 46.4453 64.7304 47.1154 64.0757 43.7549L68.8683 42.8188L71.4923 56.2557L66.6996 57.1917V57.1968Z"
        fill="#14AA40"
        stroke="#003512"
        strokeWidth="0.527473"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M53.3265 58.3789C55.5254 57.9514 56.8659 55.33 56.3204 52.5238C55.7749 49.7175 53.5501 47.7891 51.3511 48.2165C49.1522 48.644 47.8118 51.2654 48.3572 54.0716C48.9027 56.8779 51.1275 58.8063 53.3265 58.3789Z"
        fill="#005D1F"
        stroke="#003512"
        strokeWidth="0.527473"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.6571 57.5096C40.7673 57.5096 41.6673 56.6095 41.6673 55.4994C41.6673 54.3892 40.7673 53.4893 39.6571 53.4893C38.5469 53.4893 37.647 54.3892 37.647 55.4994C37.647 56.6095 38.5469 57.5096 39.6571 57.5096Z"
        fill="#D0EED8"
        stroke="#003512"
        strokeWidth="0.527473"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M65.2162 52.3489C66.3263 52.3489 67.2263 51.4489 67.2263 50.3388C67.2263 49.2286 66.3263 48.3286 65.2162 48.3286C64.106 48.3286 63.2061 49.2286 63.2061 50.3388C63.2061 51.4489 64.106 52.3489 65.2162 52.3489Z"
        fill="#D2FA52"
        stroke="#003512"
        strokeWidth="0.527473"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.0332 54.8393L45.7799 54.3022"
        stroke="#003512"
        strokeWidth="0.527473"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M58.9553 51.7294L61.702 51.1924"
        stroke="#003512"
        strokeWidth="0.527473"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.7869 49.2232L57.9628 46.6504"
        stroke="#003512"
        strokeWidth="0.527473"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M61.9628 58.1183L45.3957 61.3509L46.209 60.1438L44.9968 59.3254L61.5639 56.0928L60.7557 57.305L61.9628 58.1183Z"
        fill="#14AA40"
        stroke="#003512"
        strokeWidth="0.527473"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M76.3515 33.3315H36.9976V49.9549H76.3515V33.3315Z"
        fill="#F1F5F7"
        stroke="#003512"
        strokeWidth="0.527473"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M74.822 34.7949H38.5269V48.4875H74.822V34.7949Z"
        fill="#F1F5F7"
        stroke="#003512"
        strokeWidth="0.527473"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.4064 34.7949C43.4064 38.2168 39.9027 38.2168 39.9027 41.6438C39.9027 45.0656 43.4064 45.0656 43.4064 48.4926H38.5269V34.8H43.4064V34.7949Z"
        fill="#14AA40"
        stroke="#003512"
        strokeWidth="0.527473"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M69.9421 48.4867C69.9421 45.0649 73.4458 45.0649 73.4458 41.6379C73.4458 38.216 69.9421 38.216 69.9421 34.7891H74.8217V48.4816H69.9421V48.4867Z"
        fill="#14AA40"
        stroke="#003512"
        strokeWidth="0.527473"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M56.6742 46.8193C58.9144 46.8193 60.7303 44.5018 60.7303 41.6431C60.7303 38.7843 58.9144 36.4668 56.6742 36.4668C54.4341 36.4668 52.6182 38.7843 52.6182 41.6431C52.6182 44.5018 54.4341 46.8193 56.6742 46.8193Z"
        fill="#005D1F"
        stroke="#003512"
        strokeWidth="0.527473"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.7282 43.6531C44.8384 43.6531 45.7383 42.7531 45.7383 41.643C45.7383 40.5328 44.8384 39.6328 43.7282 39.6328C42.618 39.6328 41.718 40.5328 41.718 41.643C41.718 42.7531 42.618 43.6531 43.7282 43.6531Z"
        fill="#D0EED8"
        stroke="#003512"
        strokeWidth="0.527473"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M69.6198 43.6531C70.73 43.6531 71.6299 42.7531 71.6299 41.643C71.6299 40.5328 70.73 39.6328 69.6198 39.6328C68.5096 39.6328 67.6096 40.5328 67.6096 41.643C67.6096 42.7531 68.5096 43.6531 69.6198 43.6531Z"
        fill="#D2FA52"
        stroke="#003512"
        strokeWidth="0.527473"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.1653 41.6426H49.9631"
        stroke="#003512"
        strokeWidth="0.527473"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M63.385 41.6426H66.1879"
        stroke="#003512"
        strokeWidth="0.527473"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M49.9639 36.4668H63.3854"
        stroke="#003512"
        strokeWidth="0.527473"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M65.1137 48.4871H48.2346L49.2628 47.459L48.2346 46.4258H65.1137L64.0857 47.459L65.1137 48.4871Z"
        fill="#14AA40"
        stroke="#003512"
        strokeWidth="0.527473"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M76.2797 59.5098H69.9679V53.1929H63.6409V59.5098H57.324V65.8369H63.6409V72.1538H69.9679V65.8369H76.2797V59.5098Z"
        fill="#D0EED8"
        stroke="#003512"
        strokeWidth="0.527473"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_550_4052"
        x="0.901098"
        y="0.901098"
        width="106.198"
        height="103.939"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="10.5495" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_550_4052"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_550_4052"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
// eslint-disable-next-line react/prop-types
export const CheckGreenIcon = ({ fill, ...props }) => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M32 0C14.3268 0 0 14.3268 0 32C0 49.6732 14.3268 64 32 64C49.6732 64 64 49.6732 64 32C64 14.3268 49.6732 0 32 0ZM32.0012 59.8708C16.6897 59.8708 4.13021 47.4766 4.13021 31.9999C4.13021 16.6885 16.5244 4.12891 32.0012 4.12891C47.3127 4.12891 59.8721 16.5231 59.8721 31.9999C59.8721 47.3112 47.4779 59.8708 32.0012 59.8708ZM50.2732 24.3921L26.9855 47.493C26.3784 48.0952 25.398 48.0913 24.7958 47.4842L13.7147 36.3136C13.1125 35.7066 13.1164 34.7262 13.7235 34.124L14.8229 33.0335C15.43 32.4313 16.4104 32.4352 17.0125 33.0423L25.9127 42.0143L47.0018 21.0943C47.6089 20.4921 48.5893 20.496 49.1915 21.1031L50.282 22.2024C50.8843 22.8095 50.8803 23.7899 50.2732 24.3921Z"
      fill={fill || '#14AA40'}
    />
  </svg>
);
// eslint-disable-next-line react/prop-types
export const CheckErrorIcon = ({ fill, ...props }) => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M32.0012 4.12891C47.3071 4.12891 59.8721 16.5257 59.8721 31.9999C59.8721 47.3923 47.4063 59.8708 32.0012 59.8708C16.6148 59.8708 4.13021 47.4112 4.13021 31.9999C4.13021 16.6188 16.595 4.12891 32.0012 4.12891ZM32 0C14.3281 0 0 14.3333 0 32C0 49.677 14.3281 64 32 64C49.6719 64 64 49.677 64 32C64 14.3333 49.6719 0 32 0ZM30.5174 15.4837H33.4824C34.3628 15.4837 35.0661 16.2169 35.0295 17.0966L34.1263 38.774C34.0917 39.6035 33.4094 40.2579 32.5792 40.2579H31.4206C30.5905 40.2579 29.9081 39.6033 29.8735 38.774L28.9703 17.0966C28.9338 16.2169 29.637 15.4837 30.5174 15.4837ZM31.9983 42.8385C30.003 42.8385 28.3854 44.4561 28.3854 46.4515C28.3854 48.4468 30.003 50.0644 31.9983 50.0644C33.9937 50.0644 35.6112 48.4468 35.6112 46.4515C35.6112 44.4561 33.9937 42.8385 31.9983 42.8385Z"
      fill={fill || '#93000A'}
    />
  </svg>
);
